var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconRotateLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00046 8.00046C3.34361 8.00046 2.00046 9.34361 2.00046 11.0005V19.0005C2.00046 20.6573 3.34361 22.0005 5.00046 22.0005H13.0005C14.6573 22.0005 16.0005 20.6573 16.0005 19.0005V11.0005C16.0005 9.34361 14.6573 8.00046 13.0005 8.00046H5.00046ZM5.00046 10.0005H13.0005C13.5527 10.0005 14.0005 10.4482 14.0005 11.0005V19.0005C14.0005 19.5527 13.5527 20.0005 13.0005 20.0005H5.00046C4.44818 20.0005 4.00046 19.5527 4.00046 19.0005V11.0005C4.00046 10.4482 4.44818 10.0005 5.00046 10.0005ZM13.6317 1.20191L13.5409 1.28884L11.6138 3.37833C11.2757 3.74493 11.2628 4.29823 11.5661 4.67878L11.6486 4.77011L13.5975 6.68229C13.9917 7.06907 14.6249 7.06304 15.0117 6.66882C15.3687 6.30492 15.391 5.73745 15.0823 5.34808L14.9982 5.25467L14.7376 5.00088C15.4616 4.97318 16.1902 5.10415 16.8786 5.39638C19.4205 6.47535 20.6065 9.41066 19.5275 11.9526C19.3117 12.4609 19.5489 13.048 20.0572 13.2638C20.5656 13.4796 21.1527 13.2424 21.3685 12.734C22.879 9.17536 21.2187 5.06593 17.6601 3.55537C16.7033 3.14926 15.6883 2.96574 14.6796 3.00165L14.7278 2.95164L15.0111 2.64477C15.3567 2.27001 15.3615 1.70213 15.0409 1.32248L14.954 1.23171C14.5792 0.88608 14.0113 0.881288 13.6317 1.20191Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconRotateLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconRotateLeft.348478b790db77ac378a02291803a22f.svg";